import { Button, type ButtonProps, Typography } from "@mui/material";

export const LoginButton = ({ children, ...props }: ButtonProps) => {
  return (
    <Button {...props}>
      <Typography
        variant="button"
        sx={{
          textTransform: "capitalize",
          fontSize: "16px",
          lineHeight: 1,
          fontWeight: 400,
          flex: "1 0 auto",
          textAlign: "left",
        }}
      >
        {children}
      </Typography>
    </Button>
  );
};
